/**
 * Service Notifications - API Tracking
 * GET /api/v1/notifications/, PATCH .../read/
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingNotification {
  id: string;
  type: string;
  type_display?: string;
  title: string;
  message: string;
  trip_id?: string | null;
  metadata?: Record<string, unknown> | null;
  is_read: boolean;
  created_at: string;
  updated_at: string;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

/**
 * Liste des notifications de l'utilisateur connecté.
 */
export async function fetchTrackingNotifications(
  accessToken: string | undefined
): Promise<TrackingNotification[]> {
  const client = getClient(accessToken);
  const response = await client.get<TrackingNotification[] | { results: TrackingNotification[] }>(
    "/api/v1/notifications/"
  );
  const data = response.data;
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data)
    return (data as { results: TrackingNotification[] }).results;
  return [];
}

/**
 * Marquer une notification comme lue.
 */
export async function markNotificationRead(
  accessToken: string | undefined,
  notificationId: string
): Promise<TrackingNotification> {
  const client = getClient(accessToken);
  const { data } = await client.patch<TrackingNotification>(
    `/api/v1/notifications/${notificationId}/read/`,
    {}
  );
  return data;
}
